module.exports = __webpack_public_path__ + "db38b9eae518f668fad6dbb4cda48568.svg";